<template lang="">
	<div class="">
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <h3 class="mt-2 mb-5 ml-11 font-weight-black">Resultado</h3>
    <div class="d-flex flex-column justify-center align-center">
      <v-card
        v-for="(history, index) in reports"
        :key="index"
        class="d-flex align-center justify-content-center mt-3"
        width="800"
        height="470"
      >
        <div class="rounded borderGreen" style="height: 450px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
        <div class="">
          <span class="font-weight-black pl-10 d-flex flex-column" style="font-size: 14px">Url Atual</span>
          <span class="d-flex align-center">
            <span
              class="mt-3 d-flex align-center pa-5 reponsive-history-reports rounded"
              style="border: 2px solid var(--grey-day-020); height: 48px; width: 700px; margin-left: 40px; margin-right: 20px; background: var(--grey-day-020)"
            >{{history.long_url}}</span>
          </span>
          <span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url destino</span>
          <span class="d-flex align-center">
            <input
              v-model="history.old_long_url"
              class="mt-3 d-flex align-center pa-5 reponsive-history-reports"
              style="border: 2px solid var(--grey-day-020); height: 48px; width: 700px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020); word-break: break-all"
            />
          </span>
          <span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Criada em:</span>
          <span class="d-flex align-center">
            <span
              class="mt-3 d-flex align-center pa-5 reponsive-history-reports"
              style="border: 2px solid var(--grey-day-020); height: 48px; width: 700px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
            >{{history.date_log}}</span>
          </span>
          <span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Cliques</span>
          <span class="d-flex align-center">
            <span
              class="mt-3 d-flex align-center pa-5 reponsive-history-reports"
              style="border: 2px solid var(--grey-day-020); height: 48px; width: 700px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
            >{{history.qt_clicks}}
            </span>
          </span>
        </div>
      </v-card>
    </div>
	</div>
</template>
<script>
export default {
  props: [
		'reports'
  ],
  methods: {
    closeForm () {
      this.$emit('close')
    },
    closeModal () {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
 .responsive-history-reports {
	width: 1119px !important;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-long {
		width: 500px !important;
	}
	.reponsive-history-reports {
		width: 715px !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/ReportsHistory.vue